import React from 'react';

interface LegalContactBlockProps {
  description: string;
  discord: string;
  discordAction: string;
  email: string;
  owner: string;
}

const LegalContactBlock: React.FC<LegalContactBlockProps> = ({
  description,
  discord,
  discordAction,
  email,
  owner,
}) => (
  <>
    <p className="text-lg text-gray-300 mb-4">{description}</p>
    <ul className="space-y-2">
      <li className="flex items-start text-gray-300">
        <span className="text-primary-400 font-bold mr-2">•</span>
        <span><strong>{discord} :</strong> {discordAction}</span>
      </li>
      <li className="flex items-start text-gray-300">
        <span className="text-primary-400 font-bold mr-2">•</span>
        <span>
          <strong>{email} :</strong>{' '}
          <a href="mailto:support@opsecours.fr" className="text-primary-400 hover:text-primary-300 underline">
            support@opsecours.fr
          </a>
        </span>
      </li>
      <li className="flex items-start text-gray-300">
        <span className="text-primary-400 font-bold mr-2">•</span>
        <span><strong>{owner} :</strong> Bondi51</span>
      </li>
    </ul>
  </>
);

export default LegalContactBlock;
